import { tw } from '@repo/ui';

interface TotalDoodProps {
  hasDood: boolean;
  formattedTotal: string;
  isLoading: boolean;
}

export const TotalDood: React.FC<TotalDoodProps> = ({
  hasDood,
  formattedTotal,
  isLoading,
}) => {
  if (!hasDood) return null;

  return (
    <div
      className={tw(
        'flex flex-col items-center rounded-xl bg-[#0B0B0B]',
        'border border-white/40 px-4 py-5 text-white md:py-10',
        'absolute -left-8 -right-8 top-0',
        'shadow-md shadow-white/20 md:-left-12 md:-right-12',
      )}
    >
      <div className='z-10 flex w-full flex-col items-center justify-center'>
        <div className='relative'>
          <p
            className={tw(
              'z-10 -mb-2 text-[45px] font-bold md:mb-0 md:text-[88px]',
              isLoading ? 'animate-pulse' : null,
            )}
          >
            {isLoading ? 'loading...' : hasDood ? formattedTotal : '0'}
          </p>
          {isLoading ? null : (
            <p
              className={tw(
                'absolute inset-0 -mb-2 font-bold opacity-70 blur-xl',
                'text-[45px] md:text-[88px]',
              )}
            >
              {hasDood ? formattedTotal : '0'}
            </p>
          )}
        </div>
        <p className={tw('text-2xl font-semibold text-[#05FFA9] md:text-3xl')}>
          $DOOD WAITING
        </p>
      </div>
    </div>
  );
};
